export const GENERAL_ONBOARDING_STEPS = {
  WELCOME: "welcome",
  HELP: "help",
  FINISH: "finish",
};
